var React = require('react');

function WalkingPolyclusterInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M98.6959 74.5366L68.8922 89.5761L70.7694 56.2456L98.6959 74.5366Z","stroke":"#143673","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M10.0678 144.655L15.7308 153.035L5.64137 153.749L10.0678 144.655Z","stroke":"#143673","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M27.0604 8.70258L47.0949 13.2563L33.1339 28.3299L27.0604 8.70258Z","fill":"#C99CEF","key":2})]);
}

WalkingPolyclusterInline.defaultProps = {"width":"109","height":"161","viewBox":"0 0 109 161","fill":"none"};

module.exports = WalkingPolyclusterInline;

WalkingPolyclusterInline.default = WalkingPolyclusterInline;
